var _style, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconReactionSmile = function SvgIconReactionSmile(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDE6E;}\n\t.st1{fill:#102236;}\n\t.st2{fill:#FF3C6E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -12.4264 30)",
    className: "st0",
    cx: 30,
    cy: 30,
    rx: 30,
    ry: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.4,22.5l-4.7-2.4l4.7-2.4c0.7-0.4,1-1.2,0.6-1.9c-0.4-0.7-1.2-1-1.9-0.6l-7.1,3.6c-0.5,0.3-0.8,0.8-0.8,1.3 c0,0,0,0,0,0c0,0,0,0,0,0c0,0.5,0.3,1.1,0.8,1.3l7.1,3.6c0.2,0.1,0.4,0.2,0.6,0.2c0.5,0,1-0.3,1.3-0.8 C49.4,23.8,49.2,22.9,48.4,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,22.5l4.7-2.4L12,17.8c-0.7-0.4-1-1.2-0.6-1.9c0.4-0.7,1.2-1,1.9-0.6l7.1,3.6c0.5,0.3,0.8,0.8,0.8,1.3 c0,0,0,0,0,0c0,0,0,0,0,0c0,0.5-0.3,1.1-0.8,1.3l-7.1,3.6c-0.2,0.1-0.4,0.2-0.6,0.2c-0.5,0-1-0.3-1.3-0.8 C11,23.8,11.3,22.9,12,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.9,31.1c0,10.5,8.9,19,19.9,19c11,0,19.9-8.5,19.9-19H9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.6,39.5c-4.8-2.1-11.1-3.4-17.8-3.4s-13,1.3-17.8,3.4c3.2,6.3,10,10.6,17.8,10.6 C37.6,50.1,44.3,45.8,47.6,39.5z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconReactionSmile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_reaction_smile.4ae5afe5.svg";
export { ForwardRef as ReactComponent };